import React from 'react';
import './LifecycleBadge.css';

interface LifecycleBadgeProps {
    stage: string | undefined | null;
}

const LIFECYCLE_COLORS: Record<string, { background: string; color: string }> = {
    design:       { background: '#6c757d', color: '#ffffff' },
    development:  { background: '#0d6efd', color: '#ffffff' },
    preview:      { background: '#ffc107', color: '#212529' },
    production:   { background: '#198754', color: '#ffffff' },
    deprecated:   { background: '#fd7e14', color: '#ffffff' },
    retired:      { background: '#dc3545', color: '#ffffff' },
};

const LifecycleBadge: React.FC<LifecycleBadgeProps> = ({ stage }) => {
    const trimmedStage = stage?.trim();
    if (!trimmedStage) {
        return null;
    }

    const normalized = trimmedStage.toLowerCase();
    const style = LIFECYCLE_COLORS[normalized] || { background: '#6c757d', color: '#ffffff' };
    const displayLabel = trimmedStage.charAt(0).toUpperCase() + trimmedStage.slice(1).toLowerCase();

    return (
        <span
            className="lifecycle-badge"
            style={{ backgroundColor: style.background, color: style.color }}
        >
            {displayLabel}
        </span>
    );
};

export default LifecycleBadge;
